import React from 'react';
import {InfoMedia} from '../../components';

const CounterOne = ({className})=> (
  <div className={`position-relative ${className || ''}`}>    
    <div className="counter-shape1"></div>
    <div className="bg-black z-index-common space background-image" style={{backgroundImage: 'url(images/bg/counter-bg-1-1.jpg)'}}>
      <div className="container">
        <div className="row justify-content-between gy-4">
          <div className="col-6 col-lg-auto">
            <InfoMedia className="counter-media"
              image="images/icon/count-1-1.png"
              title="5"
              info="Government Institutions"
            />
          </div>
          <div className="col-6 col-lg-auto">
            <InfoMedia className="counter-media"
              image="images/icon/count-1-2.png"
              title="100K+"
              info="Users"
            />
          </div>
          <div className="col-6 col-lg-auto">
            <InfoMedia className="counter-media"
              image="images/icon/count-1-3.png"
              title="10"
              info="Skilled Experts"
            />
          </div>
          <div className="col-6 col-lg-auto">
            <InfoMedia className="counter-media"
              image="images/icon/count-1-4.png"
              title="5"
              info="Happy Clients"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
);


export default CounterOne;